import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwMyRequestsComponent } from './pw-my-requests.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { PwMyRequestsRoutingModule } from './pw-my-requests-routing.module';
import { PwThanksPageModule } from '../pw-thanks-page/pw-thanks-page.module';

@NgModule({
  declarations: [
    PwMyRequestsComponent
  ],
  exports: [
    PwMyRequestsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CustomDatePickerModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatSortModule,
    PwMyRequestsRoutingModule,
    PwThanksPageModule
  ]
})
export class PwMyRequestsModule { }
